module.exports = __webpack_public_path__ + "static/media/interior4.50f457e5.jpeg";